import { useEffect, useRef } from "react";
import { useDispatch } from "react-redux";
import { useSearchParams } from "react-router-dom";
// routes
import Router from "./routes";
// theme
import ThemeProvider from "./theme";
// components
import ScrollToTop from "./components/scroll-to-top";
import { StyledChart } from "./components/chart";
import LoginPage from "./pages/LoginPage";
import AlertsContainer from "./components/AlertsContainer";
import { get } from "src/utils/networkUtils";
import { setUserLevel } from "./store/slices/userLevelSlice";
import { setTenants, setSelectedTenant } from "./store/slices/tenantSlice";

// ----------------------------------------------------------------------

export default function App() {
  //localStorage.removeItem("token");
  const token = localStorage.getItem("token");
  const dispatch = useDispatch();
  const [searchParams] = useSearchParams();
  const tenantsInitializedRef = useRef(false);

  useEffect(() => {
    if (token) {
      get("admin/user-level")
        .then((response) => {
          dispatch(setUserLevel(response.levels || []));
        })
        .catch((error) => {
          console.error("Error fetching user level", error);
        });
    }

    // Only fetch tenants once on mount
    if (!tenantsInitializedRef.current) {
      tenantsInitializedRef.current = true;
      get("admin/tenants")
        .then((response) => {
          const tenants = response.tenants || [];
          dispatch(setTenants(tenants));

          if (tenants.length > 0) {
            // Check URL for tenantId first
            const urlTenantId = searchParams.get("tenantId");
            let tenantToSelect = null;

            if (urlTenantId) {
              // Try to find tenant from URL
              const tenantFromUrl = tenants.find(
                (t) => t.tenantId === parseInt(urlTenantId, 10)
              );
              if (tenantFromUrl) {
                tenantToSelect = tenantFromUrl;
              }
            }

            // If no tenant from URL (or URL tenant not found), default to first tenant
            if (!tenantToSelect) {
              tenantToSelect = tenants[0];
            }

            dispatch(setSelectedTenant(tenantToSelect));
          }
        })
        .catch((error) => console.error("Error fetching tenants", error));
    }
  }, [token, dispatch, searchParams]);

  if (!token) {
    return (
      <ThemeProvider>
        <LoginPage />
      </ThemeProvider>
    );
  }
  return (
    <ThemeProvider>
      <ScrollToTop />
      <StyledChart />
      <AlertsContainer />
      <Router />
    </ThemeProvider>
  );
}
